export const FAMILIES_PER_PAGE = 48;
export const RESULTS_PER_PAGE = 48;
export const DEFAULT_DESIGNS_SORT_ORDER = 6;
export const PRICE_REFETCH_INTERVAL = 6 * 60 * 60 * 1000;
export const MAX_MOBILE_WIDTH = 960;
export const DATALAYER_PUSH_TIMEOUT = 10000;

// Trustpilot Widget
export const TRUSTPILOT_BUSINESS_UNIT_ID = '4bbfeb5e000064000505538e';
export const LANDING_TRUSTPILOT_WIDGET_DESKTOP_TEMPLATE_ID = '53aa8912dec7e10d38f59f36';
export const LANDING_TRUSTPILOT_WIDGET_MOBILE_TEMPLATE_ID = '539ad0ffdec7e10e686debd7';
export const TRUSTPILOT_WIDGET_HEIGHT = '100px';
export const TRUSTPILOT_WIDGET_WIDTH = '190px';
export const TRUSTPILOT_WIDGET_MOBILE_HEIGHT = '100px';
export const TRUSTPILOT_WIDGET_MOBILE_WIDTH = '350px';
export const TRUSTPILOT_WIDGET_TEMPLATE_ID = '5419b6ffb0d04a076446a9af';
export const LANDING_TRUSTPILOT_WIDGET_DESKTOP_HEIGHT = '150px';
export const LANDING_TRUSTPILOT_WIDGET_MOBILE_HEIGHT = '350px';
export const LANDING_TRUSTPILOT_WIDGET_WIDTH = '100%';
export const EXCLUDED_LOCALES = ['cs-CZ', 'pl-PL', 'en-XX', 'pt-PT'];
